import type { TestShackReportInspection } from "@/pages/products/test-shack/models/TestShackReport";
import { TestShackReportNoSpecLegend } from "@/pages/products/test-shack/shared/components/report/TestShackReportNoSpec";
import { TestShackReportSectionRevCard as SharedSectionRevCard } from "@/pages/products/test-shack/shared/components/report/TestShackReportSectionRevCard";
import type { TestShackReportSectionRev } from "../models/TestShackReportSectionRev";
import { hasMissingSpecs } from "../utils/format";
import { M1TestShackReportDimensionTable } from "./M1TestShackReportDimensionTable";
import { M1TestShackReportDrawingPanel } from "./M1TestShackReportDrawingPanel";

interface TestShackReportSectionRevCardProps {
	sectionRev: TestShackReportSectionRev;
	isCollapsed: boolean;
	showMinTargetMax: boolean;
	onToggle: () => void;
	onError: (error: Error) => void;
	onViewImages: (inspection: TestShackReportInspection) => void;
}

export const M1TestShackReportSectionRevCard = ({
	sectionRev,
	isCollapsed,
	showMinTargetMax,
	onToggle,
	onError,
	onViewImages,
}: TestShackReportSectionRevCardProps) => (
	<SharedSectionRevCard
		sectionRev={sectionRev}
		isCollapsed={isCollapsed}
		onToggle={onToggle}
		footer={
			hasMissingSpecs(sectionRev.columns) && <TestShackReportNoSpecLegend />
		}
	>
		<M1TestShackReportDimensionTable
			sectionRev={sectionRev}
			showMinTargetMax={showMinTargetMax}
		/>
		<M1TestShackReportDrawingPanel
			sectionRev={sectionRev}
			onError={onError}
			onOpen={() => onViewImages(sectionRev.rows[0].inspection)}
		/>
	</SharedSectionRevCard>
);
